import { Transition } from '@headlessui/react'
import clsx from 'clsx'
import { ReactNode, useState } from 'react'

interface CopyToClipboardProps {
  onCopy?: () => void
  className?: string
  text: string
  children: ReactNode
}

function CopyToClipboard({ children, text, className, onCopy }: CopyToClipboardProps) {
  const classes = clsx('absolute -top-12 left-0 right-0 z-20 m-auto grid place-content-center', className)
  const [showCopied, setShowCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setShowCopied(true)
      setTimeout(() => setShowCopied(false), 2000)
      onCopy?.()
    } catch (error) {
      console.error('Failed to copy to clipboard:', error)
    }
  }

  return (
    <div className={`relative inline-grid place-items-center`} onClick={handleCopy}>
      {children}
      <Transition
        show={showCopied}
        enter='transition-all duration-500'
        leave='transition-all duration-500'
        enterFrom='opacity-0 translate-y-2'
        enterTo='opacity-100 translate-y-0'
        leaveFrom='opacity-100 translate-y-0'
        leaveTo='opacity-0 -translate-y-2'
      >
        <div className={classes}>
          <div className='bg-brand rounded-lg px-3 py-2 text-xs font-bold text-white shadow-md'>Copied!</div>
        </div>
      </Transition>
    </div>
  )
}

export default CopyToClipboard
